export const scrollToTop = () => {
  var parent_origin = "*";
  window.parent.postMessage({ task: "scroll_top" }, parent_origin);
  const iframe = document.getElementById("iframe-container");
  iframe && iframe.scrollIntoView();
};

export const scrollToHeader = () => {
  var parent_origin = "*";
  window.parent.postMessage({ task: "scroll_header" }, parent_origin);
  const parent = document.getElementById("theme-header");
  parent && parent.scrollIntoView();
};
